//
//
//
//
//
//
//
//
//

import Swiper from 'swiper'

const DEFAULT_EVENTS = [
  'beforeDestroy',
  'slideChange',
  'slideChangeTransitionStart',
  'slideChangeTransitionEnd',
  'slideNextTransitionStart',
  'slideNextTransitionEnd',
  'slidePrevTransitionStart',
  'slidePrevTransitionEnd',
  'transitionStart',
  'transitionEnd',
  'touchStart',
  'touchMove',
  'touchMoveOpposite',
  'sliderMove',
  'touchEnd',
  'click',
  'tap',
  'doubleTap',
  'imagesReady',
  'progress',
  'reachBeginning',
  'reachEnd',
  'fromEdge',
  'setTranslate',
  'setTransition',
  'resize'
]

export default {
  name: 'HSlider',

  props: {
    options: {
      type: Object,
      default: () => ({})
    }
  },

  data: () => ({
    Slider: null
  }),

  mounted() {
    this.$nextTick(() => {
      this.mountInstance()
    })
  },

  beforeDestroy() {
    this.$nextTick(() => {
      this.Slider.destroy && this.Slider.destroy()
      delete this.Slider
    })
  },

  methods: {
    bindEvents() {
      const vm = this
      DEFAULT_EVENTS.forEach(eventName => {
        this.Slider.on(eventName, function () {
          vm.$emit(eventName, ...arguments)
          vm.$emit(
            eventName.replace(/([A-Z])/g, '-$1').toLowerCase(),
            ...arguments
          )
        })
      })
    },

    mountInstance() {
      const options = { ...this.options }
      this.Slider = new Swiper(this.$el, options)
    },

    slidePrev() {
      this.Slider.slidePrev()
    },

    slideNext() {
      this.Slider.slideNext()
    }
  }
}
